// extracted by extract-css-chunks-webpack-plugin
module.exports = {"body":"_3Dc6re","container":"_1dKcSy"};